import React, { memo } from 'react';

const Footer = memo(() => {
    return (
        <footer class="footer footer-center p-4 bg-[white]">
            <div>
                <p>Copyright © 2023 - All right reserved Ragib Sahriar</p>
            </div>
        </footer>
    );
});

export default Footer;